import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
import { createUnitValidation } from "../../validation/InventoryInfo";
import Button from "../Reusable/Button";
import TextField from "../Reusable/TextField";

const CreateUnit = ({ setOpenUnitFormPopup }) => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["unit"],
  });
  const { handleSubmit, setValue, getValues, control, setError } = useForm<any>(
    {
      resolver: yupResolver(createUnitValidation),
    }
  );
  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.UNIT;
    const formData = {
      ...values,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setOpenUnitFormPopup((prev) => !prev);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className={tw`min-w-[400px]`}>
      <form onSubmit={handleSubmit((data) => handleCreate(data, setError))}>
        <div className={tw`flex  flex-col `}>
          <TextField
            name="name"
            control={control}
            label="Name"
            placeholder="Enter Name "
          />
          <TextField
            name="short_code"
            control={control}
            label="Short Code"
            placeholder="Enter Short Code"
          />
        </div>
        <div className={tw`mt-4 w-full `}>
          <div className={tw`w-32 ml-auto`}>
            <Button label="Save" isLoading={isPostLoading} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateUnit;
